<template>
  <div>
    <div class="mb-12 s:mb-14" v-for="(preferences, section) in emailPreferences" :key="section">
      <div class="mb-6">
        <b-headline type="h4" typography="h4" class="mb-2 text-left">
          {{ $t(`emailPreferences.sections.${section}.title`) }}
        </b-headline>
        <b-paragraph class="text-left">
          {{ $t(`emailPreferences.sections.${section}.description`) }}
        </b-paragraph>
      </div>
      <content-box>
        <div v-for="(preference, optin, index) in preferences" :key="index">
          <div class="flex justify-between">
            <div>
              <b-subheadline font-weight="medium" font-size="small">
                {{ $t(`emailPreferences.sections.${section}.optins.${optin}.title`) }}
              </b-subheadline>
              <b-legal v-if="preference.frequency">
                {{ $t(`emailPreferences.frequencies.${preference.frequency}`) }}
              </b-legal>
            </div>
            <sliding-toggle
              @input="(value) => onPreferenceChange(section, optin, value)"
              :value="emailPreferences[section][optin].subscribed"
              :name="optin"
              :disabled="emailPreferences[section][optin].disabled"
            />
          </div>
          <b-paragraph class="text-left">
            {{ $t(`emailPreferences.sections.${section}.optins.${optin}.description`) }}
          </b-paragraph>
          <line-divider color="lightest-grey" v-if="isNotLast(index, preferences)" />
        </div>
      </content-box>
    </div>
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import BSubheadline from "@/component-library/b-subheadline"
import BLegal from "@/component-library/b-legal"
import BParagraph from "@/component-library/b-paragraph"
import SlidingToggle from "@/component-library/sliding-toggle"

import ContentBox from "@/component-library/content-box"
import LineDivider from "@/component-library/line-divider"
import globals from "@/utils/globals"

export default {
  name: "CategoryPreference",
  components: {
    BHeadline,
    BSubheadline,
    BLegal,
    BParagraph,
    SlidingToggle,
    ContentBox,
    LineDivider
  },
  props: {
    emailPreferences: {
      type: Object,
      required: true
    },
    updateCallback: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      platform: globals.platform
    }
  },
  computed: {
    isEmailLinkVisible() {
      return this.platform === "web"
    }
  },
  methods: {
    isNotLast(index, preferences) {
      return index !== Object.keys(preferences).length - 1
    },
    onPreferenceChange(category, email, value) {
      const didValueChange = this.emailPreferences[category][email].subscribed !== value

      if (!didValueChange) {
        return
      }

      this.updateCallback({
        category,
        email,
        value
      })
    }
  }
}
</script>
